
import {
  Divider,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import { RightPanel } from "../../../../../../components/RightPanel";
import { IPolicyDriverAbstracts } from "../../../../../../redux/policyCommon/policyCommon.types";
import { formatDate } from "../../../../../../helpers";

export interface IPolicyAbstractsPreviewProps {
  open: boolean;
  data: IPolicyDriverAbstracts;
  onClose: () => void;
}

export const PolicyAbstractsPreview: React.FC<IPolicyAbstractsPreviewProps> = ({
  open,
  data,
  onClose,
}) => {
  const theme = useTheme();

  return (
    <>
      <RightPanel
        heading="Preview"
        //subHeading="Add notes or comments"
        open={open}
        onClose={onClose}
        width="70%"
      >
        <Stack
          p={4}
          sx={{
            border: `1px solid ` + theme.palette.grey[400],
            borderRadius: "5px",
          }}
        >
          <Typography variant="h4" fontWeight={600} textAlign={"center"}>
            ONTARIO Driving Record
          </Typography>
          {/* <Typography
            variant="body1"
            fontWeight={500}
            mb={3}
            color="error.main"
            textAlign={"center"}
          >
            ***Number of Convictions **
          </Typography> */}
          <Grid container spacing={1}>
            <Grid item xs={12} md={4}>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="h5" fontWeight={600}>
                  Licence Number:
                </Typography>
                <Typography variant="body1">{data.licence}</Typography>
              </Stack>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="h5" fontWeight={600}>
                  Name:
                </Typography>
                <Typography variant="body1">{data.name}</Typography>
              </Stack>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="h5" fontWeight={600}>
                  Gender:
                </Typography>
                <Typography variant="body1">{data.gender}</Typography>
              </Stack>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="h5" fontWeight={600}>
                  Address:
                </Typography>
                <Typography variant="body1">{data.address}</Typography>
              </Stack>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="h5" fontWeight={600}>
                  Reference:
                </Typography>
                <Typography variant="body1">{data.reference}</Typography>
              </Stack>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="h5" fontWeight={600}>
                  Comment:
                </Typography>
                <Typography variant="body1">{data.comment}</Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} md={4}></Grid>
            <Grid item xs={12} md={4}>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="h5" fontWeight={600}>
                  Expiry Date:
                </Typography>
                <Typography variant="body1">{data.expiry_date}</Typography>
              </Stack>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="h5" fontWeight={600}>
                  Birth Date:
                </Typography>
                <Typography variant="body1">{data.birthdate}</Typography>
              </Stack>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="h5" fontWeight={600}>
                  Height:
                </Typography>
                <Typography variant="body1">{data.height}</Typography>
              </Stack>
            </Grid>
          </Grid>

          <Grid container spacing={1} mt={4}>
            <Grid item xs={12} md={4}>
              <Stack direction={"row"} alignItems={"center"} spacing={5}>
                <Typography variant="h5" fontWeight={600}>
                  Demrit Points:
                </Typography>
                <Typography variant="body1">{data.demerit_points}</Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} md={4}>
              <Stack direction={"row"} alignItems={"center"} spacing={5}>
                <Typography variant="h5" fontWeight={600}>
                  Class:
                </Typography>
                <Typography variant="body1">{data.class}</Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} md={4}>
              <Stack direction={"row"} alignItems={"center"} spacing={5}>
                <Typography variant="h5" fontWeight={600}>
                  Conditions:
                </Typography>
                <Typography variant="body1">{data.conditions}</Typography>
              </Stack>
            </Grid>
          </Grid>

          <Divider sx={{ mt: 4, mb: 4 }} />

          <Grid container spacing={1}>
            <Grid item xs={12} md={4}>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="h5" fontWeight={600}>
                  Status::
                </Typography>
                <Typography variant="body1">{data.status}</Typography>
              </Stack>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="h5" fontWeight={600}>
                  Requested By:
                </Typography>
                <Typography variant="body1">{data.requested_by}</Typography>
              </Stack>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="h5" fontWeight={600}>
                  Requested on:
                </Typography>
                <Typography variant="body1">{data.requested_on}</Typography>
              </Stack>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="h5" fontWeight={600}>
                  Print Date:
                </Typography>
                <Typography variant="body1">{data.print_date}</Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} md={4}></Grid>
            <Grid item xs={12} md={4}>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="h5" fontWeight={600}>
                  Issue Date:
                </Typography>
                <Typography variant="body1">
                  {formatDate(data.issue_date)}
                </Typography>
              </Stack>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="h5" fontWeight={600}>
                  User ID:
                </Typography>
                <Typography variant="body1">{data.user_id}</Typography>
              </Stack>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="h5" fontWeight={600}>
                  Reply Date:
                </Typography>
                <Typography variant="body1">{data.reply_date}</Typography>
              </Stack>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="h5" fontWeight={600}>
                  Reprint Date:
                </Typography>
                <Typography variant="body1">{data.reprint_date}</Typography>
              </Stack>
            </Grid>
          </Grid>

          <Grid container spacing={1} mt={4}>
            <Grid item xs={12}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>Date</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>
                        CONVICTIONS, DISCHARGES AND OTHER ACTIONS
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.convictions_details &&
                      data.convictions_details.map((item, index) => {
                        return (
                          <TableRow key={index}>
                            <TableCell>{formatDate(item.date)}</TableCell>
                            <TableCell>{item.convictions}</TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>

          <Stack mt={4}>
            <Typography variant="body1" fontWeight={600} textAlign={"center"}>
              *** END OF REPORT / FIN DU RAPPORT ***
            </Typography>
          </Stack>

          <Grid container mt={4}>
            <Grid item xs={12} md={3}>
              <Typography variant="body1" fontWeight={600}>
                Licence Number
              </Typography>
              <Typography variant="body1">{data.licence || "--"}</Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              <Typography variant="body1" fontWeight={600}>
                ReplyDt
              </Typography>
              <Typography variant="body1">
                {formatDate(data.reply_date)}
              </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              <Typography variant="body1" fontWeight={600}>
                BirthDt
              </Typography>
              <Typography variant="body1">
                {formatDate(data.birthdate)}
              </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              <Typography variant="body1" fontWeight={600}>
                ExpiryDt
              </Typography>
              <Typography variant="body1">
                {formatDate(data.expiry_date)}
              </Typography>
            </Grid>
            <Grid item xs={12} md={1.5}>
              <Typography variant="body1" fontWeight={600}>
                Class
              </Typography>
              <Typography variant="body1">{data.class}</Typography>
            </Grid>
            <Grid item xs={12} md={1.5}>
              <Typography variant="body1" fontWeight={600}>
                PT
              </Typography>
              <Typography variant="body1">{data.pt}</Typography>
            </Grid>
          </Grid>
          <Stack mt={4}>
            <Typography variant="body1" fontWeight={600} textAlign={"center"}>
              *** END OF REPORT / FIN DU RAPPORT ***
            </Typography>
          </Stack>
          <Stack mt={4}>
            <Typography variant="body1" fontWeight={600} color="error.main" textAlign={"end"}>
             {`Receipt Number : ${data.receipt_number}`}
            </Typography>
          </Stack>

        </Stack>
      </RightPanel>
    </>
  );
};
